export default "__VITE_ASSET__8KlHeGCt__"